<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="https://gbappsdl.org" class="footer-link">gbappsdl.org</a> This site only shares guides and news about GBWhatsApp. All rights belong to their owners.</p>
    </div>
    <div class="footer-links">
      <a href="/about/" class="footer-link">About Us</a>
      <a href="/privacy/" class="footer-link">Privacy Policy</a>
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
    </div>
</div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  margin-top: 48px;
  padding: 22px 0;
}
@media (max-width: 768px) {
  .footer {
    margin-top: 56px;
    padding: 16px 0 56px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-top: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
